export const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

const MIDNIGHT_HOUR = 0;
const MIDNIGHT_MINUTE = 0;

/**
 * Calculates the expiration time until midnight.
 *
 * This function returns the remaining time until midnight in days.
 * It is compatible with localStorageUtil's expiration parameter,
 * which expects the expiration time in days.
 *
 * @returns {number} Time until midnight in days.
 */
export const getExpirationUntilMidnightInDays = (): number => {
  const now = new Date();
  const midnight = new Date();
  // Sets the time to exactly midnight tomorrow
  midnight.setHours(MIDNIGHT_HOUR, MIDNIGHT_MINUTE, 0, 0);
  midnight.setDate(midnight.getDate() + 1);

  // Calculates the remaining time until midnight in days
  return (midnight.getTime() - now.getTime()) / MILLISECONDS_PER_DAY;
};

export const getNextMidnightTimeInMS = (): number => {
  const midnight = new Date();
  midnight.setHours(MIDNIGHT_HOUR, MIDNIGHT_MINUTE, 0, 0);
  midnight.setDate(midnight.getDate() + 1);

  return midnight.getTime();
};
